import ShopOrderResourcePagingResultModel from '../../generated/types/model/resource/ShopOrderResourcePagingResultModel';

export default class ShopOrderResourcePagingResultViewModel extends ShopOrderResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
